import React from 'react';
import {
  Accordion as MaterialAccordion,
  AccordionProps as MaterialAccordionProps,
} from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import classnames from 'classnames';

interface AccordionProps extends MaterialAccordionProps {}

const useStyles = makeStyles(() => ({
  accordionSummaryRoot: {
    borderRight: 0,
    borderLeft: 0,
  },
}));

export const Accordion = ({ ...rest }: AccordionProps) => {
  const { classes } = useStyles();
  return (
    <MaterialAccordion
      elevation={0}
      variant="outlined"
      square
      disableGutters
      {...rest}
      classes={{
        ...rest.classes,
        root: classnames(classes.accordionSummaryRoot, rest.classes?.root),
      }}
    />
  );
};
